// import TelegramChannelContainer from '@/containers/channel/TelegramChannelContainer';
// import TwitterChannelContainer from '@/containers/channel/TwitterChannelContainer';
import ChannelContainer from '@/containers/channel/ChannelContainer';

export default [
  // {
  //   path: '/channels/telegram',
  //   name: 'Telegram',
  //   meta: { requiresAuth: true },
  //   component: TelegramChannelContainer,
  // },
  // {
  //   path: '/channels/twitter',
  //   name: 'Twitter',
  //   meta: { requiresAuth: true },
  //   component: TwitterChannelContainer,
  // },
  {
    path: '/channels',
    name: 'Channel',
    meta: { requiresAuth: true, action: 'view', subject: 'channels' },
    component: ChannelContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/channel.js